import { MediaChange, MediaObserver } from '@ngbracket/ngx-layout'
import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class MatchMediaService {
  activeMediaQuery: string
  onMediaChange: BehaviorSubject<string> = new BehaviorSubject<string>('')

  constructor(private mediaObserver: MediaObserver) {
    this.activeMediaQuery = ''

    this.mediaObserver.asObservable().subscribe((changes: MediaChange[]) => {
      if (this.activeMediaQuery !== changes[0].mqAlias) {
        this.activeMediaQuery = changes[0].mqAlias
        this.onMediaChange.next(changes[0].mqAlias)
      }
    })
  }
}
